import { Grid, Image, List, Paper, Text, Title, Flex } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';
import { RiVipCrownFill } from "react-icons/ri";
import "./UniversityRankingCard.css";
import NusLogo from "../../../images/NusLogo.png";
import FgvLogo from "../../../images/FgvLogo.png";
import MsuLogo from "../../../images/MsuLogo.jpg";

export default function UniversityRankingCard({university, count, avgReturn, rank}) { 
    const isMobile = useMediaQuery('(max-width: 1090px)');

    return <List.Item p="lg" className="border-top-gray" >
        <Grid align="center">
            <Grid.Col span={1}>
                <Title inline align="center" className={(rank <= 3 ? (rank === 1 ? "gold" : rank === 2 ? "silver" : "bronze") : "")} >{rank}</Title> 
            </Grid.Col>
            <Grid.Col span="content" align="center" justify="center">          
                <Paper pos="relative" shadow="sm" radius={9999} withBorder>
                    <Image className={rank <= 3 ? "rank " + (rank === 1 ? "gold" : rank === 2 ? "silver" : "bronze") : ""} 
                        alt="user image" src={university === "National University of Singapore" 
                            ? NusLogo
                            : (university === "FGV" 
                                ? FgvLogo
                                : MsuLogo)}
                        width={60} height={60} fit="cover" radius={9999} />
                    {rank === 1 ? <RiVipCrownFill className="crown" /> : null}
                </Paper> 
            </Grid.Col>

            <Grid.Col span={isMobile ? 7 : 5}>
                <Text weight="bolder" size={isMobile? 18: 24}
                    color={university === "National University of Singapore" 
                            ? "var(--color-nuswap-brand-1)" 
                            : (university === "FGV" 
                                ? "var(--color-nuswap-secondary-2)" 
                                : "blue")}>{university}</Text>
                    {isMobile && <Flex align="center" wrap="nowrap" justify="flex-start" columnGap={3} py="sm">
                        <Text size="sm" inline align="left">Total Participant:</Text>
                        <Text size="sm" inline>{count}</Text>
                    </Flex>}
                    {isMobile && <Flex align="center" wrap="nowrap" justify="flex-start" columnGap={3}>
                        <Text size="sm" inline align="left">Total P/L:</Text>
                        <Text size="sm" inline>{avgReturn.toFixed(2)}</Text>
                    </Flex>}
            </Grid.Col>

            {!isMobile && <Grid.Col span={2}>
                <Text size="md" align="left">Total Participants:</Text>
                <Text size="md">{count}</Text>
            </Grid.Col>}

            {!isMobile && (
            <Grid.Col span={2}>
                <Text size="md" align="left">Total P/L:</Text>
                <Text size="md">{avgReturn.toFixed(3)}</Text>
                {university !== "National University of Singapore" ? (
                <Text color="red" size="sm">Normalized to 25 participants</Text>) 
                : (<Text size="sm"></Text>)}
            </Grid.Col>
            )}
             
        </Grid>
    </List.Item>
}
